import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/SUA/refresh', {
            withCredentials: true
        });
        //console.log(response);
        setAuth(prev => {
            console.log(prev);
            console.log(response);
            return {
                ...prev,
                roles: response.data.roles,
                accessToken: response.data.accessToken,
                Empresas:response.data.Empresas,
                nombre:response.data.nombre,
                email:response.data.email
            }
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;